import { render } from "./CustomerForm.vue?vue&type=template&id=1b1fcec6&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=1b1fcec6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b1fcec6"

export default script